<template>
<div id="stores">

      <div class="container">

        <div class="row">
          <div class="col-md-12">
            <div class="title d-none d-sm-block">
              Aproveite cupons de descontos em nossas <span>lojas afiliadas</span>
            </div>
            <div class="title d-block d-sm-none">
              Lojas <span>afiliadas</span>
            </div>
            <router-link class="all" to="/descontosdobem">veja mais</router-link>
          </div>

          <div class="col-md-12">
            <div class="stores row" v-if="featuredStores">

              <div class="col-md-2" v-for="c in featuredStores" :key="c.StoreId">
                <div class="item" @click="openStore(c.slug)">
                  <div class="image">
                    <img :src="c.logo" />
                  </div>
                  <!-- <div class="content">
                    <h5>{{c.name}}</h5>
                  </div> -->
                </div>
              </div>

            </div>

            <div class="waiting row" v-else>
              <h4>Aguarde, carregando...</h4>
            </div>
          </div>
        </div>

      </div>

    </div>
</template>

<script>
import Functions from '../../utils/functions'
import CouponService from '../../services/coupon';

export default {
  props: ['stores'],
  data(){
    return {
      featuredStores: null
    }
  },
  mounted (){
    if(this.stores){
      this.featuredStores = this.stores.filter((e) => {
        return (e.isFeatured);
      });
      this.featuredStores = Functions.arrayShuffle(this.featuredStores)
      this.featuredStores.splice(6, this.featuredStores.length - 6);
    }
  },
  methods: {
    openStore(slug){
      this.$router.push('/descontosdobem/store/' + slug);
    }
  },
  watch: {
    stores: {
      handler(newList, oldList) {
        this.featuredStores = newList.filter((e) => {
          return (e.isFeatured);
        });
        this.featuredStores = Functions.arrayShuffle(this.featuredStores)
        this.featuredStores.splice(6, this.featuredStores.length - 6);
      },
      deep: true
    },
  }
}
</script>

<style scoped lang="scss">
#stores{
  background-color: #f4f4f4;
  min-height: 350px;
  padding-top: 20px;
  padding-bottom: 60px;

  .title{
    margin-top: 40px;
    font-size: 28px;
    font-family: RalewayRegular;

    span{
      color: #00AE39;
    }
  }

  .all{
    position: absolute;
    right: 30px;
    top: 50px;
    color: #00AE39;
    text-decoration: none;
    font-family: RalewayBold;
  }

  .waiting{
    h4{
      margin: 0 auto;
      margin-top: 40px;
    }
  }

  .stores{

    .item{
      background-color: #fff;
      margin-top: 20px;
      font-family: RalewayRegular;
      width: 100%;
      height: 100%;
      cursor: pointer;

      &:hover{
        box-shadow: 0px 1px 20px #888888;
      }

      .image{
        width: 100%;
        height: 100%;
        overflow: hidden;

        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .content{
        margin-top: 10px;
        padding: 5px;
        text-align: center;
        h5{
          font-size: 18px;
          font-family: RalewayBold;
        }

        .tags{
          padding-top: 10px;
          padding-bottom: 10px;
          a{
            padding: 5px;
            border-radius: 5px;
            background-color: #00AE39;
            color: #fff;
            text-decoration: none;
          }
        }

        span{
          b{
            color: #00AE39;
          }
        }

      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/StoresSection.vue